import { env } from "build/env";
var normalizeHost = hostOrUrl => {
  if (!hostOrUrl) return "";
  var withProtocol = hostOrUrl.includes("://") ? hostOrUrl : "".concat(window.location.protocol, "//").concat(hostOrUrl);
  try {
    return new URL(withProtocol).hostname;
  } catch (_unused) {
    return "";
  }
};
export var configuredTakeawayHost = normalizeHost(env.URL_TAKEAWAY);
export var configuredSwissTakeawayHost = normalizeHost(env.URL_TAKEAWAY_CH) || (configuredTakeawayHost !== null && configuredTakeawayHost !== void 0 && configuredTakeawayHost.endsWith(".com") ? configuredTakeawayHost.replace(/\.com$/, ".ch") : "");
export var shouldAskSwissRedirect = function (store) {
  var {
    enableSwissOrderRedirect = true
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSwissStore = (store === null || store === void 0 ? void 0 : store.storeViewOrder) === "miscusi_ch_sv";
  var isCurrentHostSourceTakeaway = configuredTakeawayHost ? window.location.hostname === configuredTakeawayHost : false;
  var hasValidSwissTargetHost = !!configuredSwissTakeawayHost;
  return enableSwissOrderRedirect && isSwissStore && isCurrentHostSourceTakeaway && hasValidSwissTargetHost;
};
export var getSwissRedirectUrl = (store, _ref) => {
  var {
    orderPath,
    orderFromRestaurantPath,
    bookPath,
    bookFromRestaurantPath
  } = _ref;
  var redirectUrl = new URL(window.location.href);
  redirectUrl.hostname = configuredSwissTakeawayHost;
  var storeIdentifier = store === null || store === void 0 ? void 0 : store.ls_store_id;
  var currentPath = window.location.pathname;
  var isOrderFlow = currentPath.startsWith(orderPath) || currentPath.startsWith(orderFromRestaurantPath);
  var isBookingFlow = currentPath.startsWith(bookPath) || currentPath.startsWith(bookFromRestaurantPath);
  if (storeIdentifier) {
    if (isOrderFlow) {
      redirectUrl.pathname = "".concat(orderFromRestaurantPath, "/").concat(storeIdentifier);
    } else if (isBookingFlow) {
      redirectUrl.pathname = "".concat(bookFromRestaurantPath, "/").concat(storeIdentifier);
    }
  }
  if (store !== null && store !== void 0 && store.cps) {
    redirectUrl.searchParams.set("cps", store.cps);
  }
  return redirectUrl.toString();
};